import { render } from "./PayOutDealSlaPopup.vue?vue&type=template&id=5dfad512&ts=true"
import script from "./PayOutDealSlaPopup.vue?vue&type=script&lang=ts"
export * from "./PayOutDealSlaPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__